import React, { useCallback } from "react";
import { useDispatch } from "react-redux";

import { userRoles } from "@awe-web/shared/lib";
import { Translation as T } from "@awe-web/shared/lib";
import { TypeArea } from "../../../components/layout.js";
import { Row, Col } from "../../../components/grid.js";
import { Button } from "../../../components/form.js";
import { ScreenSection, ScreenHeading } from "../../../components/screen.js";
import { TextLinkList } from "../../../components/text_link_list.js";
import RequestResetPasswordTokenForm from "../../../user/components/request_reset_password_token_form";
import { B2B_Login, B2B_SignUpRequest } from "../../../routing/routes.js";
import { requestNewPassword, initialize } from "../../../user/actions.js";
import { useInitialize } from "../../../util/react.js";

const HEADING = "FSD0000097";
const LINK_LOGIN = "FSD0000253";
const LINK_SIGN_UP = "ALG0000194";

export default function B2B_RequestResetPasswordToken() {
  const dispatch = useDispatch();

  const onSubmit = useCallback(async ({ login, captchaToken }) => {
    const isSuccess = await dispatch(requestNewPassword(login, userRoles.B2B, captchaToken));
    return isSuccess;
  }, [dispatch]);


  const init = useCallback(async () => await dispatch(initialize()), [dispatch]);
  const isReady = useInitialize(init);
  if (!isReady) {
    return null;
  }

  return (
    <div className="request-reset-password-token">
      <ScreenSection main dark>
        <TypeArea>
          <Row>
            <Col
              tablet={{ cols: 4, offset: 2 }}
              desktop={{ cols: 4, offset: 4 }}
            >
              <ScreenHeading>
                <T code={HEADING} />
              </ScreenHeading>

              <RequestResetPasswordTokenForm
                backlinkLocation={B2B_Login.path()}
                onSubmit={onSubmit}
              >
                <TextLinkList>
                  <Button tertiary to={B2B_Login.path()}>
                    <T code={LINK_LOGIN} />
                  </Button>
                  <Button tertiary to={B2B_SignUpRequest.path()}>
                    <T code={LINK_SIGN_UP} />
                  </Button>
                </TextLinkList>
              </RequestResetPasswordTokenForm>
            </Col>
          </Row>
        </TypeArea>
      </ScreenSection>
    </div>
  );
}
